import React, { useContext, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

const maxNameLength = 4;

export default function IconDocument({
  extColor,
  isAutoscallable = true,
  sizeKey = '18x22',
  onClick,
  style,
  name,
}: IconProps & { name: string }) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.primary;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  name = `${name.slice(0, maxNameLength)}`;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={{ ...style, overflow: 'visible' }}
      width={w}
      height={h}
      viewBox="0 0 18 22"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.25 6.1875V19.25C17.25 19.9793 16.9603 20.6788 16.4445 21.1945C15.9288 21.7103 15.2293 22 14.5 22H13.125V20.625H14.5C14.8647 20.625 15.2144 20.4801 15.4723 20.2223C15.7301 19.9644 15.875 19.6147 15.875 19.25V6.1875H13.125C12.578 6.1875 12.0534 5.9702 11.6666 5.58341C11.2798 5.19661 11.0625 4.67201 11.0625 4.125V1.375H3.5C3.13533 1.375 2.78559 1.51987 2.52773 1.77773C2.26987 2.03559 2.125 2.38533 2.125 2.75V15.125H0.75V2.75C0.75 2.02065 1.03973 1.32118 1.55546 0.805456C2.07118 0.289731 2.77065 0 3.5 0L11.0625 0L17.25 6.1875Z"
      />
      <text
        y="22px"
        x="100%"
        style={{
          transform: 'translate(calc(-100% - 5px), 0%)',
          transformBox: 'fill-box',
          fontSize: 8,
          textTransform: 'uppercase',
          fontWeight: 'bold',
        }}
      >
        {name}
      </text>
    </svg>
  );
}
